import React, { useState, useEffect } from "react";
import { Modal, Input, Form, Row, Col, Typography, Select, message } from "antd";
import { platformApi } from "../../../../api";

const { Item } = Form;
const { Text, Title } = Typography;
const { Option } = Select;

const CityForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [editable, setEditable] = useState(props.editable);
  const [states, setStates] = useState([]);

  const { form, open, close, data, modify, emitData } = props;
  const { getFieldDecorator, setFieldsValue, resetFields, validateFields } = form;

  useEffect(() => {
    setEditable(props.editable);
    if (data) {
      setFieldsValue({
        name: data.name,
        code: data.code,
        state: data.state || (data.State ? data.State.id : undefined),
      });
    }
  }, [data, props.editable]);

  useEffect(() => {
    if (open) {
      fetchStates();
    }
  }, [open]);

  const fetchStates = () => {
    platformApi
      .get("/api/csc/state/all")
      .then((res) => {
        if (res.data && res.data.code === 200) {
          setStates(res.data.data || []);
        }
      })
      .catch((err) => {
        console.error("Error fetching states for City form:", err);
        message.error("Failed to load states");
      });
  };

  const handleSubmit = () => {
    validateFields((err, values) => {
      if (!err) {
        setLoading(true);
        const payload = {
          name: values.name.trim(),
          code: values.code ? values.code.trim() : "",
          state: values.state,
        };
        if (data && data.id) {
          payload.id = data.id;
        }
        emitData(payload);
        setLoading(false);
        resetFields();
        close();
      }
    });
  };

  return (
    <Modal
      title={<Title level={4}>{data && data.id ? "Edit City" : "Add City"}</Title>}
      visible={open}
      okText={editable ? "Save" : "Modify"}
      onCancel={() => {
        resetFields();
        close();
      }}
      okButtonProps={{ loading, disabled: !modify && !editable }}
      onOk={() => (editable ? handleSubmit() : setEditable(true))}
    >
      <Form layout="vertical">
        <Row type="flex" justify="space-between">
          <Col span={24}>
            <Item label={<Text strong>State</Text>} colon={false} required>
              {getFieldDecorator("state", {
                rules: [{ required: true, message: "Please select state!" }],
              })(
                <Select
                  disabled={!editable}
                  placeholder="Select State"
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) => {
                    const label = Array.isArray(option.props.children)
                      ? option.props.children.join("")
                      : String(option.props.children || "");
                    return label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                  }}
                >
                  {states.map((s) => {
                    const labelText = s.Country ? `${s.name} (${s.Country.name})` : s.name;
                    return (
                      <Option key={s.id} value={s.id}>
                        {labelText}
                      </Option>
                    );
                  })}
                </Select>
              )}
            </Item>
          </Col>
        </Row>

        <Row type="flex" justify="space-between">
          <Col span={24}>
            <Item label={<Text strong>City Name</Text>} colon={false} required>
              {getFieldDecorator("name", {
                rules: [{ required: true, message: "Please enter city name!" }],
              })(
                <Input
                  disabled={!editable}
                  placeholder="Enter City Name (e.g. Chennai)"
                  maxLength={100}
                />
              )}
            </Item>
          </Col>
        </Row>

        <Row type="flex" justify="space-between">
          <Col span={24}>
            <Item label={<Text strong>City Code</Text>} colon={false} required>
              {getFieldDecorator("code", {
                rules: [{ required: true, message: "Please enter city code!" }],
              })(
                <Input
                  disabled={!editable}
                  placeholder="Enter City Code (e.g. MAA)"
                  maxLength={20}
                />
              )}
            </Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

const WrappedCityModal = Form.create({ name: "city_form" })(CityForm);

export default WrappedCityModal;
